import styled from 'styled-components'
import { GreatPrimer } from '~/components/Typography'
import { mediaqueries } from '~/utils/mediaqueries'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${({ isScrollable }) =>
    isScrollable &&
    `
    overflow-x: scroll;
    margin: 0 -20px;
    padding: 0 20px;


    & > div {
      flex-wrap: nowrap;
      & > label {
        flex: none;
      }
    } 
  `}

  ${({ isScrollable, name }) =>
    isScrollable &&
    name === 'style' &&
    `
    margin-top: -30px;
    padding-top: 30px;
  `}

  @media ${`${mediaqueries.sm} and ${mediaqueries.max.md}`} {
    flex: 0 0 100%;
  }
`

export const Group = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const SizeLabel = styled(GreatPrimer)`
  cursor: pointer;
  text-transform: none !important;
  user-select: none;
  border-radius: 4px;
  font-weight: 500;

  span {
    color: #c0c4ce;
    margin-left: 15px;
  }

  ${({ theme: { color, toRem }, disabled }) => `
      padding: ${[toRem(12), toRem(20)].join(' ')};
      background: ${color('light')};
      margin-right: ${toRem(20)} !important;
      margin-bottom: ${toRem(20)};

      ${disabled && 'pointer-events: none; opacity: .4;'}
  `}
`

export const SizeRadio = styled.input`
  display: none;

  &:checked + label {
    ${({ theme: { color } }) => ` 
      color: ${color('light')};
      background: ${color('core')};
    `}

    span {
      color: rgba(255, 255, 255, 0.5);
    }
  }
`

export const CharacterLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  margin: 0 5px 5px 0;
  @media ${mediaqueries.md} {
    margin: 0 1px 1px 0;
  }

  ${({ theme: { color, toRem, setDimensions } }) => `
      ${setDimensions(toRem(45))}
      background: ${color('light')}
    `}
`

export const CharacterRadio = styled.input`
  display: none;

  &:checked + label {
    ${({ theme: { color } }) => `
      color: ${color('light')};
      background: ${color('core')};
    `}
  }
`

export const StyleLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;

  ${({ theme: { color, toRem }, fill, background }) => `
      width: 80px;
      height: 80px;
      margin-right: ${toRem(22)};
      margin-bottom: ${toRem(10)};
      background: ${background};
      border-radius: 6px;

      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
        transition: .15s ease opacity;
        background: ${color('dark')};
        border-radius: inherit;
      }
      
      &:hover:after {
        opacity: .2;
      }

      svg:nth-of-type(2) {
        height: 45px;
        fill: ${fill}
      }

      svg:nth-of-type(1) {
        position: absolute;
        top: -15px;
        right: -15px;
        opacity: 0;
        transition: .15s ease opacity;
        z-index: 2;
      }
  `}
`
export const Radio = styled.input`
  display: none;

  &:checked + label {
    svg:nth-of-type(1) {
      opacity: 1;
    }
  }
`

export const ColorLabel = styled(StyleLabel)`
  ${({ theme: { toRem, setDimensions, color }, colors }) => `
    ${setDimensions(toRem(60))}
    overflow: hidden;
    flex-wrap: wrap;
    border-radius: 6px;
    border: 1px solid ${color('accent', 90)};
    position: relative;
    margin-right: 15px;
    margin-bottom: 20px;
    span {
      flex:0 0 100%;
      height: 50%;
      display: block;
      
      &:nth-of-type(1) {
        background: ${colors[0]};
      }
      &:nth-of-type(2) {
        background: ${colors[1]};
      }
    }

    &:after {
      content: none;
    }

    svg {
      position: absolute;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%); 
    }
  `}
`

export const SwitchWrapper = styled.div`
  width: 100%;
  border-radius: 6px;
  padding: 9px;
  margin-bottom: 20px;

  ${({ theme: { color } }) => ` 
      background: ${color('light')};
      `}

  @media ${`${mediaqueries.sm} and ${mediaqueries.max.md}`} {
    flex: 0 0 calc(50% - 10px);
    margin: 0 20px 0 0;
  }
`

export const SwitchLabel = styled(GreatPrimer)`
  display: inline-flex;
  align-items: center;
  position: relative;
  z-index: 0;
  width: 100%;
  cursor: pointer;
  user-select: none;
  &:before,
  &:after {
    transition: all 0.15s ease;
  }

  &:before {
    content: '';
    width: 60px;
    height: 36px;
    border-radius: 60px;
    margin-right: 15px;
    ${({ theme: { color } }) => ` 
      background: ${color('accent', 90)};
      `}
  }
  &:after {
    content: '';
    width: 17px;
    height: 17px;
    border-radius: 50%;
    position: absolute;
    left: calc(36px / 2);
    transform: translate(-50%);
    z-index: 1;
    ${({ theme: { color } }) => ` 
      background: ${color('accent')};
      `}
  }

  @media ${`${mediaqueries.sm} and ${mediaqueries.max.md}`} {
    flex: 0 0 100%;
  }
`

export const SwitchCheckbox = styled.input`
  display: none;

  &:checked + label {
    &:before {
      ${({ theme: { color } }) => ` 
      background: ${color('core')};
      `}
    }

    &:after {
      ${({ theme: { color } }) => ` 
      background: ${color('light')};
      `}
      transform: translateX(100%);
    }
  }
`
